/* global axios */
import ApiClient from './ApiClient';

class OrdersAPI extends ApiClient {
  constructor() {
    super('orders', { accountScoped: true });
  }

  create({ conversationId, orderInfo }) {
    return axios.post(this.url, { conversation_id: conversationId, order_info: orderInfo });
  }

  get(params = {}) {
    const query = new URLSearchParams(params).toString();
    const requestURL = query ? `${this.url}?${query}` : this.url;
    return axios.get(requestURL);
  }

  search(params = {}) {
    const query = new URLSearchParams(params).toString();
    const requestURL = query ? `${this.url}?${query}` : this.url;
    return axios.get(requestURL);
  }

  filter(queryPayload, otherParams = {}) {
    const query = new URLSearchParams(otherParams).toString();
    const requestURL = query
      ? `${this.url}/filter?${query}`
      : `${this.url}/filter`;
    return axios.post(requestURL, queryPayload);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  importOrder(source, payload) {
    return axios.post(`${this.url}/import`, { source, payload });
  }

  takecareMessage(id, message) {
    return axios.post(`${this.url}/${id}/takecare_message`, { message });
  }
}

export default new OrdersAPI();
